import { LatLngAlt } from "../../../types.js";

const stream: LatLngAlt[] = [
  [-11.651144, 166.948736, 10.8],
  [-11.651018, 166.948886, 10.8],
];

export default stream;
